var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoSicobeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 126.06 117.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #232a61;\n        stroke: #232a61;\n        stroke-width: .3px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.68,
    y: 14.6,
    width: 78.75,
    height: 99.29,
    rx: 6.85,
    ry: 6.85
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    className: "cls-2",
    d: "M31.22,100.85v-1.91c0-.39.27-.73.65-.81,2.98-.45,5.2-2.99,5.25-6.01,0-3.03-1.57-4.87-5.54-6.27-2.87-1.03-4.04-1.77-4.04-2.83,0-.93.68-1.9,2.87-1.9,1.35,0,2.68.25,3.93.77.43.18.92-.03,1.1-.46.01-.03.03-.07.03-.1l.56-2.11c.11-.41-.11-.84-.51-1-1.1-.42-2.25-.68-3.42-.76-.44-.03-.77-.4-.77-.84v-1.3c0-.46-.38-.84-.84-.84h-1.59c-.46,0-.84.38-.84.84v1.64c0,.38-.26.72-.63.81-2.85.46-4.96,2.91-5.01,5.8,0,3.24,2.43,4.9,6,6.1,2.5.84,3.57,1.63,3.57,2.9s-1.3,2.05-3.24,2.05c-1.6-.02-3.18-.37-4.64-1.03-.42-.19-.92,0-1.11.43-.02.04-.03.08-.04.13l-.58,2.24c-.1.4.1.81.48.98,1.36.57,2.8.93,4.27,1.06.43.04.76.4.76.83v1.55c0,.46.37.84.84.84h1.63c.46,0,.84-.38.84-.84h0M51.15,49.98h20.93l-1.71-7.39h-17.5l-1.73,7.39ZM76.86,49.98c1.25.05,2.23,1.08,2.24,2.33v9.33c0,.99-.62,1.87-1.55,2.2v1.88c0,1.5-1.22,2.72-2.72,2.72s-2.72-1.22-2.72-2.72h0v-1.75h-20.98v1.75c0,1.5-1.22,2.72-2.72,2.72s-2.72-1.22-2.72-2.72h0v-1.89c-.92-.34-1.53-1.21-1.53-2.19v-9.33c0-1.25.99-2.28,2.24-2.33l1.96-8.45c.48-2.12,2.37-3.62,4.55-3.6h17.48c2.17-.02,4.07,1.48,4.54,3.61l1.95,8.45ZM70.35,42.57h0M52.86,42.57h0M50.33,54.26c1.72,0,3.11,1.39,3.11,3.11,0,1.72-1.39,3.11-3.11,3.11s-3.11-1.39-3.11-3.11h0c0-1.72,1.39-3.11,3.11-3.11M55.77,54.26h2.33v6.22h-2.33v-6.22ZM65.1,54.26h2.33v6.22h-2.33v-6.22ZM60.44,54.26h2.35v6.22h-2.33l-.02-6.22ZM72.88,54.26c1.72,0,3.11,1.39,3.11,3.11,0,1.72-1.39,3.11-3.11,3.11s-3.11-1.39-3.11-3.11h0c0-1.72,1.39-3.11,3.11-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    className: "cls-3",
    d: "M79.11,101.69h-34.95v-4.67h34.95v4.67ZM31.7,14.6h56.74c1.29,0,2.33,1.04,2.33,2.33v94.86c0,1.29-1.04,2.33-2.33,2.33H13.01c-1.29,0-2.33-1.04-2.33-2.33V35.6c0-.68.3-1.33.81-1.77L30.06,15.29c.43-.44,1.02-.68,1.64-.68ZM34.02,19.27l-.02,16.33c0,1.28-1.04,2.32-2.32,2.32H15.35v71.54h70.76V19.27h-52.08ZM18.64,33.27h10.71v-10.72l-10.71,10.72ZM79.11,83.04h-34.95v-4.66h34.95v4.66ZM79.11,92.37h-34.95v-4.67h34.95v4.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoSicobeLight);
export default __webpack_public_path__ + "static/media/icono-sicobe-light.1422c34ed4719da72c718a7804307b69.svg";
export { ForwardRef as ReactComponent };